exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-position {\n  margin-top: 30px; }\n\n.icon-delete-coach {\n  padding-top: 5px; }\n\n.coach-padding {\n  padding-bottom: 10px; }\n\n.project-title {\n  margin-left: -12px;\n  margin-bottom: 16px; }\n\n.invalid-input-wrapper {\n  color: #cb6f67;\n  font-size: 0.8rem; }\n\n.format-percent {\n  float: right; }\n\n.estimate-link {\n  color: #000000;\n  word-wrap: break-word;\n  word-break: break-word; }\n\n.headline-padding {\n  padding-top: 8px; }\n\n.col.s4.m2.center-align.with-issue-tracker {\n  width: 14.28%; }\n  @media screen and (max-width: 880px) {\n    .col.s4.m2.center-align.with-issue-tracker {\n      width: 30%; } }\n  @media screen and (max-width: 436px) {\n    .col.s4.m2.center-align.with-issue-tracker {\n      width: 50%; } }\n\n@media screen and (max-width: 880px) {\n  .margin-mobile {\n    margin-bottom: 20px; } }\n\n@media screen and (max-width: 600px) {\n  .margin-mobile-qr {\n    margin-bottom: 14px; } }\n\n.coachescard {\n  min-height: 250px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/project-dashboard/project-dashboard.component.scss
// module id = ../../../../../src/app/components/project-dashboard/project-dashboard.component.scss
// module chunks = main